import ServicesPage from "./views/ServicesPage.vue";

const routes = [
  {
    path: '/services',
    name: 'services',
    component: ServicesPage,
    meta: {
      title: 'Services',
      requiresAuth: true
    }
  }
];

export default routes;
